// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__TK34S","noInteraction":"EventWrapper_noInteraction__2YMSp","pointerPassthrough":"EventWrapper_pointerPassthrough__zg83h"};